import React from 'react';
import { Row, Col } from 'react-bootstrap';
import BannerHero from '../../Atoms/BannerHero/BannerHero';
import TemplateHome from '../../Templates/TemplateHome/TemplateHome';

import ButtonAnchorTop from '../../Atoms/ButtonAnchorTop/ButtonAnchorTop';

import "./PageHomeOut.css";
import PageHomeBienvenido from './PageHomeBienvenido';
import PageHomeServices from './PageHomeServices';
import PageHomeOutAsegurado from './PageHomeOutAsegurado';
import PageHomeOutAyuda from './PageHomeOutAyuda';
import PageHomeOutHelp from './PageHomeOutHelp';

const PageHomeOut = () => {

    return (
        <>
            <TemplateHome>
                <Row className='justify-content-center w-100 m-0 p-0'>
                    <Col className='col-12 p-0'>
                        <BannerHero 
                            image__banner__hero={'banner__home'}
                        />
                    </Col>                
                </Row>

                <PageHomeBienvenido />

                <PageHomeServices />

                <PageHomeOutAsegurado />

                <PageHomeOutHelp />
                
            </TemplateHome>

            <ButtonAnchorTop
                action={() => window.scroll({top:0})}
            />
        </>
    );
};

export default PageHomeOut;